import { DialogId } from '@feedyou-ai/feedbot-schema'

import { Dialogs } from '../types'
import { stepAction } from '../actions'
import { getDialog } from '../../../lib/dialogs'
import { FeedbotThunk } from '../../../store/types'
import { getSleepTimeout } from './utils'
import { createNewDialog } from '../../../store/flow/thunks/createNewDialog'

export const actionTypes = {
  SET_POSTPONE: 'SET_POSTPONE',
  SET_DIALOG: 'SET_DIALOG'
} as const

export function setPostpone(postpone: number) {
  return { type: actionTypes.SET_POSTPONE, postpone }
}

export function setDialog(dialogId: DialogId) {
  return { type: actionTypes.SET_DIALOG, dialogId }
}

export function setSleepTimeoutWithDialog(
  stepId: string,
  dialogs: Dialogs,
  postpone: number
): FeedbotThunk {
  return async dispatch => {
    const timeout = await getSleepTimeout(postpone)
    if (timeout === undefined) {
      return
    }

    dispatch(stepAction(stepId, setPostpone(timeout)))

    const dialog = await getDialog(dialogs)
    if (!dialog) {
      return
    }

    if (!dialog.exists) {
      dispatch(createNewDialog(dialog.id, dialog))
    }

    dispatch(stepAction(stepId, setDialog(dialog.id)))
  }
}

export type Action = ReturnType<typeof setPostpone | typeof setDialog>
